export const normalizeCollection = (collection) => {
  if (!collection) {
    return {}
  }

  const {
    name,
    description,
    creation_date: creationDate,
    domains_count: domainsCount,
    files_count: filesCount,
    ip_addresses_count: ipAddressesCount,
    last_modification_date: lastModificationDate,
    references_count: referencesCount,
    subscribers_count: subscribersCount
  } = collection

  return {
    name,
    description,
    creationDate,
    lastModificationDate,
    counts: {
      domainsCount,
      filesCount,
      ipAddressesCount,
      referencesCount,
      subscribersCount,
    }
  }
}
